// Shared constants between frontend and backend

// Maximum age for superadmin token before role is stripped/fresh login required (in seconds)
// 86400 = 1 day, 3600 = 1 hour, 1800 = 30 minutes, 900 = 15 minutes
export const MAX_SUPERADMIN_AGE_SECONDS = 86400; // 1 day for now
